export interface IAddress {
  id: number;
  line1: string;
  line2: string;
  zip_code: string;
  city: string;
  country: string;
  additional_info: string;
}
export interface IBillingInformation {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
}

export interface IBankingInformation {
  id: number;
  account_name: string;
  bank_name: string;
  account_number: string;
  bank_number: string;
  account_international_number: string;
  bank_international_number: string;
  bank_address: IAddress;
}

export interface IAccountResponse {
  id: number;
  account_type: AccountType;
  business_type: BusinessType;
  company_name: string;
  company_form: CompanyForm;
  company_id: string;
  first_name: string;
  last_name: string;
  contact_address: IAddress;
  contact_email: string;
  contact_phone: string;
  contact_phone_country_code: string;
  website_url: string;
  api_token: string;
  billing_email_info: IBillingInformation[];
  billing_apply_vat: boolean;
  billing_vat_id: string;
  billing_address: IAddress;
  payment_bank: IBankingInformation;
  vat_type: string;
}

export interface ISendBills {
  sendBillId: number;
  email: string;
  firstName: string;
  lastName: string;
}

export interface IAccountRequest {
  account: IAccountResponse;
  payout_method: string;
  payout_threshold: string;
  billing_due_duration: number;
  commision_fee_split: number;
  recurring_fee_value: number;
  recurring_fee_interval: number | string;
}

export interface IUser {
  id: number;
  account_type: string;
  first_name: string;
  last_name: string;
  email: string;
  status: string;
  permissions: string[];
  groups: string[];
  phone: number;
  account: number;
}

export interface ILoginResponse {
  user_id: number;
  username: string;
  exp: number;
  email: string;
  orig_iat: number;
  user: IUser;
}

export const accountTypeOptions = [
  { id: 'Admin', name: 'Admin' },
  { id: 'Advertiser', name: 'Advertiser' },
  { id: 'Publisher', name: 'Publisher' },
];

export const companyFormTypeOptions = [
  { id: 'Cooperative', name: 'Cooperative' },
  { id: 'Corporation', name: 'Corporation' },
  { id: 'Limited', name: 'Limited' },
  { id: 'Partnership', name: 'Partnership' },
  { id: 'Sole Trader', name: 'Sole Trader' },
  { id: 'Other', name: 'Other' },
];

export const publisherCompanyFormTypeOptions = [
  { id: 'Commercial', name: 'Commercial' },
  { id: 'Private', name: 'Private' },
];

export const advertiserCompanyFormTypeOptions = [
  { id: 'Commercial', name: 'Commercial' },
];

export enum UserGroup {
  GUEST = 'Guest',
  ADMIN = 'Admin',
  ACCOUNT_MANAGER = 'AccountManager',
}

export enum UserStatus {
  ACTIVE = 'Active',
  PENDING = 'Pending',
  INACTIVE = 'Inactive',
}

export enum AccountType {
  ADMIN = 'Admin',
  ADVERTISER = 'Advertiser',
  PUBLISHER = 'Publisher',
}

export enum BusinessType {
  COMMERCIAL = 'Commercial',
  PRIVATE = 'Private',
}

export enum CompanyForm {
  CORPORATIVE = 'Cooperative',
  CORPORATION = 'Corporation',
  LIMITED = 'Limited',
  PARTNERSHIP = 'Partnership',
  SOLE_TRADER = 'Sole Trader',
  OTHER = 'Other',
}

export const payoutMethodOptions = [
  { id: 'Bank transfer', name: 'Bank Transfer' },
];

export const vatTypeOptions = [
  { name: 'Germany with VAT' },
  { name: 'Germany without VAT' },
  { name: 'Europe' },
  { name: 'International' },
];

export interface UserChangeLog {
  user: string;
  change_at: Date;
  change: UserChange;
}

export enum UserChange {
  OFFER_GENERAL = 'offer_general',
  OFFER_TRACKING = 'offer_tracking',
  OFFER_TERMS = 'offer_terms',
  OFFER_TARGETING = 'offer_targeting',
  OFFER_ADS = 'offer_ads',
  OFFER_PRICE_SEGMENTS = 'offer_price_segments',
  OFFER_PRICING = 'offer_pricing',
  OFFER_ADSPACES = 'offer_adspaces',
}
